// import { gatewayClient } from 'boot/axios'
import businessClient from 'src/services/clients/business'
import {
  IMeta,
  // IServerNames,
  ICustomer,
  ICustomerUpsertArgs,
} from 'src/common/interfaces/index.js'

const ICustomerListResponse = { meta: IMeta, data: { list: [ICustomer] } }
const IBulkActivateArgs = { ids: [1], is_active: false }
const IBulkActivateResponse = { meta: IMeta, data: { update: [] } }

export const customer = {
  /**
   * @param {id: number} filter
   * @return {ICustomerListResponse}
   */
  list(filter, signal) {
    return businessClient().post('customer/portal/list', { filter }, { signal })
  },

  /**
   * @param {ICustomerUpsertArgs} data
   * @return {{upsert: [ICustomer]}}
   */
  upsert(data, signal) {
    return businessClient().post('customer/upsert', { data }, { signal })
  },

  /**
   * @param { id: number} filter
   * @return {Promise<{meta: IMeta, data: {archive: [ICustomer]}}>}
   */
  archive(filter, signal) {
    return businessClient().post('customer/archive', { filter }, { signal })
  },

  /**
   * @param {IBulkActivateArgs} data
   * @return {IBulkActivateResponse}
   */
  bulkActivate(data, signal) {
    return businessClient().post('customer/bulk/update', { data }, { signal })
  },
}
